module.exports = "<nav class=\"cw-panel-menu\">\n  <a [routerLink]=\"['/dashboard']\" [routerLinkActive]=\"'active'\">Start</a>\n  <a [routerLink]=\"['/projects']\" [routerLinkActive]=\"'active'\">Projekt</a>\n  <a [routerLink]=\"['/clients']\" [routerLinkActive]=\"'active'\">Kunder</a>\n  <a [routerLink]=\"['/settings']\" [routerLinkActive]=\"'active'\">Inställningar</a>\n</nav>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main-menu/main-menu.component.html
// module id = ./src/app/main-menu/main-menu.component.html
// module chunks = main